import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CrudService } from "@atenea-cms";

@Injectable()
export class DashboardService extends CrudService {
  getRootUrl(): string {
    return "cache";
  }

  clearCache() {
    return this.http
      .get(`/${this.rootUrl}/clear-cache`)
      .map(this.http.getJsonData);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/dashboard/shared/dashboard.service.ts